import { useParams, useNavigate } from 'react-router-dom'
import { BrandSettingsContent } from '@/components/BrandSettingsContent'

export default function BrandSettings() {
  const { brandId } = useParams<{ brandId: string }>()
  const navigate = useNavigate()

  if (!brandId) return null

  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
      <BrandSettingsContent brandId={brandId} onDeleted={() => navigate('/dashboard')} />
    </main>
  )
}
